import { SET_LANGUAGE, SET_LANGUAGE_LOADING, SET_LANGUAGE_INITIALIZED } from 'store/types/language';
import { handleError } from 'utils/helper';

export const setLanguage = (language) => {
  return {
    type: SET_LANGUAGE,
    payload: language,
  };
};

export const setLanguageLoading = (isLoading) => {
  return {
    type: SET_LANGUAGE_LOADING,
    payload: isLoading,
  };
};

export const setLanguageInitialized = (isInitialized) => {
  return {
    type: SET_LANGUAGE_INITIALIZED,
    payload: isInitialized,
  };
};

export const changeLanguageAsync = (langCode) => {
  return async (dispatch, getState) => {
    const { language } = getState();

    if (langCode === language.currentLanguage) {
      return;
    }

    dispatch(setLanguageLoading(true));

    try {
      const { default: i18n } = await import('i18n/LanguageProvider');
      if (!i18n.hasResourceBundle(langCode, 'translation')) {
        const translation = await import(`locales/${langCode}.json`);
        i18n.addResourceBundle(langCode, 'translation', translation.default);
      }

      await i18n.changeLanguage(langCode);
      dispatch(setLanguage(langCode));

      localStorage.setItem('i18nextLng', langCode);
      document.documentElement.lang = langCode;
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLanguageLoading(false));
    }
  };
};
